export const REGEXPS = Object.freeze({
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  string: /^([a-z ]+)$/mi,
  number: /^\d+$/mi,
});

export const VALIDATIONS = Object.freeze({
  required: val => Boolean(val?.trim().length),
  email: val => REGEXPS.email.test(val?.trim()),
  min(val, min) {
    if (typeof val === 'number') return val >= min;
    if (typeof val === 'string') return val.length >= min;
  },
  max(val, max) {
    if (typeof val === 'number') return val <= max;
    if (typeof val === 'string') return val.length <= max;
  },
  string: val => REGEXPS.string.test(val),
  number: val => REGEXPS.number.test(val),
});

export const EXERCISES = Object.freeze([
  {
    title: 'Mouse Fluency Check',
    description: 'Before taking your Cognitive Assessments, we’ll need to check the accuracy of your mouse. Please use your mouse to continue.',
    instruction: 'You will see two buttons side by side. Please click the two buttons <strong>with your mouse</strong> back and forth 10 times as quickly and accurately as possible. Do not use a trackpad.',
    endText: 'Nice job! You’ve successfully completed the mouse fluency check.',
    view: 'MouseButtonTest',
    numberOfSuccessAttempts: 20,
  },
  {
    title: 'Keyboard Fluency Check',
    description: 'Before taking your Cognitive Assessments, we’ll need to check the accuracy of your keyboard.  Please press the spacebar to continue.',
    instruction: 'You will see two buttons side by side. One will be labeled “Z” for the Z key and one will be labeled “M” for the M key. Please interact with the two buttons <strong>by using your keyboard</strong> and alternate typing Z and M as quickly and accurately as possible. Please locate the Z and M keys on your keyboard and press the spacebar to continue.',
    endText: 'Nice job! You’ve successfully completed the keyboard fluency check.',
    view: 'KeyboardButtonTest',
    numberOfSuccessAttempts: 20,
  },
  {
    title: 'Keyboard Fluency Check',
    description: 'Before taking your Cognitive Assessments, we’ll need to check the accuracy of your keyboard.  Please press the spacebar to continue.',
    instruction: 'You will see a series of buttons labeled “Z” and “M”. Please type the letters you see in order as quickly and accurately as possible. Please locate the Z and M keys on your keyboard and press the spacebar to continue.',
    endText: 'Nice job! You’ve completed the tech fluency tasks.',
    view: 'KeyboardStringTest',
    numberOfSuccessAttempts: 16,
  },
]);

export const STEPS = Object.freeze([
  'Introduce',
  'Instruction',
  'Exercise',
  'Done',
]);
